export interface IOrganization {
  id: string
  name: string
  apiUrl: string
}

const ALL_ORGANIZATIONS: IOrganization[] = [
  { id: 'frisco', name: 'Frisco', apiUrl: 'https://frisco.deliverider.com/api/4.1/' },
  { id: 'frisco-test', name: 'Demo', apiUrl: 'https://frisco-test.deliverider.com/api/4.1/' },
  { id: 'development', name: 'Development', apiUrl: 'https://development.deliverider.com/api/4.1/' },
]

// Matches src/ota/config.ts's OTA_CHANNEL default: an unset channel means production,
// not a wide-open non-production build. Getting this backwards would show
// "Development" on a build whose OTA behavior is already production.
const IS_PRODUCTION_CHANNEL = ['frisco-production', 'production'].includes(
  process.env.REACT_APP_OTA_CHANNEL || 'production'
)

// Single seam for a future remote-fetched list — every other lookup in this module
// goes through this function, not the const above, so a later async migration
// only changes here.
export const getOrganizations = (): IOrganization[] =>
  IS_PRODUCTION_CHANNEL
    ? ALL_ORGANIZATIONS.filter(org => org.id !== 'development')
    : ALL_ORGANIZATIONS

export const getOrganizationById = (id: string): IOrganization | undefined =>
  getOrganizations().find(org => org.id === id)

// The seller types the organization name they were given rather than picking from a
// list — case/whitespace-insensitive so "demo", " Demo ", "DEMO" all resolve the same
// name the seller was actually told.
export const getOrganizationByName = (name: string): IOrganization | undefined => {
  const normalized = name.trim().toLowerCase()
  return getOrganizations().find(org => org.name.toLowerCase() === normalized)
}
